import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function FinalCtaSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full py-16 md:py-24 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20warm%20cream%20abstract%20background%20with%20gentle%20organic%20shapes%20and%20subtle%20gradient%20blending%2C%20minimalist%20modern%20design%2C%20soft%20natural%20light%20diffusion%2C%20clean%20sophisticated%20aesthetic%2C%20subtle%20texture%20layers%2C%20warm%20neutral%20palette%2C%20elegant%20atmospheric%20look%2C%20editorial%20style&width=1600&height=600&seq=cssbuy-cta-final-v4&orientation=landscape"
          alt="CSSBuy Spreadsheet CTA"
          title="Comece agora com o melhor CSSBuy Spreadsheet"
          className="w-full h-full object-cover object-center"
          loading="lazy"
        />
      </div>
      <div className="absolute inset-0 bg-black/30"></div>
      <div className="relative z-10 w-full px-4 md:px-6 max-w-2xl mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-white mb-4">
          {t('finalCtaTitle')}
        </h2>
        <p className="text-white/80 text-sm md:text-base mb-8 leading-relaxed">
          {t('finalCtaSubtitle')}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white font-semibold text-sm whitespace-nowrap rounded-md hover:bg-primary-600 transition-colors duration-200 cursor-pointer"
          >
            {t('ctaCssbuySheet')}
          </a>
          <Link
            to="/guia-cssbuy-spreadsheet"
            className="w-full sm:w-auto px-8 py-3.5 bg-white text-foreground-900 font-semibold text-sm whitespace-nowrap rounded-md hover:bg-background-100 transition-colors duration-200 cursor-pointer"
          >
            {t('articleButton')}
          </Link>
        </div>
      </div>
    </section>
  );
}